import * as React from 'react';
import { motion, useInView } from 'framer-motion';

const AboutTeam: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  const stagger = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.5
      }
    }
  };

  return (
    <motion.section 
      ref={ref}
      className="py-16 px-4"
      variants={stagger}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      <div className="container mx-auto max-w-4xl text-center">
        <motion.h2 
          className="text-3xl text-gray-800 mb-8"
          variants={fadeInUp}
        >
          A Nossa Equipa
        </motion.h2>
        <motion.p 
          className="text-lg text-gray-600 leading-relaxed"
          variants={fadeInUp}
        >
          Contamos com uma equipa de profissionais experientes e apaixonados pela arte da beleza. 
          Cada membro da nossa equipa está comprometido em proporcionar-lhe uma experiência única e inesquecível, 
          utilizando as mais modernas técnicas e produtos de alta qualidade.
        </motion.p>
      </div>
    </motion.section>
  );
};

export default AboutTeam; 